import { apiAgent } from "../../axiosConfig";
import getApiUrl from "../utils/UrlHelper";

export const saveOrRemoveFromProfile = (props) => {
    let {setState, item, parentProps} = props
    setState({ isLoading: true });
    apiAgent({
        method: "post",
        url: getApiUrl("get_save_or_remove_post", {":id": item.id}),
        data: {},
    })
        .then((res) => {
            const is_saving = !item.is_saved;
            let success_msg = is_saving ? "Saved to the profile" : "Removed from the profile"
            setState({
                item: {...item, is_saved: !item.is_saved},
                isLoading: false,
            });
            props.toast.success(success_msg);
            setState({ show_dropdown: false })      
            if(parentProps.from === 'saved_posts')
            parentProps.removeSavedPostCallBack(item); 
        })
        .catch((err) => {
            setState({ isLoading: false });
        });
}
